import { fontSizeNumbers } from "./fontSizes";

export default {
  collapsedWidth: "6rem",
  h1FontFamily: `"Open Sans", "Helvetica", "Arial", "sans-serif"`,
  h1FontSize: `${fontSizeNumbers.h1}rem`,
  h1FontWeight: "300",
  h2FontSize: "2.88rem",
  h3FontSize: "2.56rem",
  h4FontSize: "2.24rem",
  h5FontSize: "1.92rem",
  h6FontSize: "1.6rem",
  headerFontSize: "2.5rem",
  maxWidth: "100%",
  primaryFontFamily: `"Open Sans", Helvetica, Arial, sans-serif`,
  primaryFontSize: "1.6rem",
  sidebarWidth: "30rem",
};
